import { render, staticRenderFns } from "./ProjectUtilitiesTab.vue?vue&type=template&id=351917e7"
import script from "./ProjectUtilitiesTab.vue?vue&type=script&lang=ts"
export * from "./ProjectUtilitiesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports